import { initializeApp } from "firebase/app";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyAirHm69FI7of2geCUVe-DCkq8akokjTvQ",
  authDomain: "rentel-6ae62.firebaseapp.com",
  projectId: "rentel-6ae62",
  storageBucket: "rentel-6ae62.firebasestorage.app",
  messagingSenderId: "819467064522",
  appId: "1:819467064522:web:6c26393856f702f9f65033",
  measurementId: "G-QFRQEPVSN4"
};

const app = initializeApp(firebaseConfig);
export const storage = getStorage(app);
